import Box from "../../components/Box";
import MainLayout from "../../components/layouts/MainLayout";
import Pagination from "../../components/Pagination";
import { useState, useEffect } from "react";
import moment from "moment";
import { useWhatsappBroadcastLogs } from "../../utils/LogUtilHooks";
import AlertBox from "../../components/AlertBox";

export default function WhatsappLogPage() {
  const [formFilter, setFormFilter] = useState({
    start_date: moment().startOf("month").format("YYYY-MM-DD"),
    end_date: moment().endOf("month").format("YYYY-MM-DD"),
    provider: "",
  });
  const [filter, setFilter] = useState({
    start_date: moment().startOf("month").format("YYYY-MM-DD"),
    end_date: moment().endOf("month").format("YYYY-MM-DD"),
    provider: "",
    page: 1,
    page_size: 20,
  });
  const { logs, loading, meta, errorMsg, getLogs } = useWhatsappBroadcastLogs();
  const [alert, setAlert] = useState({ show: false, message: "", type: "" });

  useEffect(() => {
    getLogs(filter);
  }, [filter, getLogs]);

  useEffect(() => {
    if (errorMsg) {
      setAlert({ show: true, message: errorMsg, type: "danger" });
    } else {
      setAlert({ show: false, message: "", type: "" });
    }
  }, [errorMsg]);

  function applyFilter() {
    let form_filter = { ...filter, ...formFilter, page: 1 };
    setFilter(form_filter);
  }

  const resetFilter = () => {
    const defaultStart = moment().startOf("month").format("YYYY-MM-DD");
    const defaultEnd = moment().endOf("month").format("YYYY-MM-DD");
    setFormFilter({ q: "", start_date: defaultStart, end_date: defaultEnd, provider: "" });
    setFilter({ q: "", start_date: defaultStart, end_date: defaultEnd, provider: "", page: 1, page_size: 20 });
  };

  const gotoPage = (page) => {
    setFilter({ ...filter, page });
  };

  return (
    <MainLayout resource_key="setting">
      <div className="container-fluid">
        <div className="d-sm-flex align-items-center justify-content-between mb-4">
          <h1 className="h3 mb-0 text-gray-800">Whatsapp Log</h1>
        </div>
        <div className="row">
          <div className="col-12">
            <Box title={`Log Broadcast Whatsapp (Total: ${meta.count || 0})`} loading={loading}>
              <div className="row mb-4">
                <div className="col-12 col-md-2">
                  <label>Tanggal Mulai</label>
                  <input
                    type="date"
                    className="form-control"
                    value={formFilter.start_date}
                    onChange={(event) =>
                      setFormFilter({ ...formFilter, start_date: event.target.value })
                    }
                  />
                </div>
                <div className="col-12 col-md-2">
                  <label>Tanggal Selesai</label>
                  <input
                    type="date"
                    className="form-control"
                    value={formFilter.end_date}
                    onChange={(event) =>
                      setFormFilter({ ...formFilter, end_date: event.target.value })
                    }
                  />
                </div>
                <div className="col-12 col-md-2">
                  <label>Provider</label>
                  <select
                    className="form-control"
                    value={formFilter.provider}
                    onChange={(event) =>
                      setFormFilter({ ...formFilter, provider: event.target.value })
                    }
                  >
                    <option value="">Semua Provider</option>
                    <option value="qontak">Qontak</option>
                    <option value="qiscus">Qiscus</option>
                  </select>
                </div>
                <div className="col-auto">
                  <button
                    className="btn btn-primary"
                    onClick={() => applyFilter()}
                    style={{ marginTop: "32px" }}
                  >
                    Filter
                  </button>
                  <button
                    className="btn btn-default"
                    onClick={() => resetFilter()}
                    style={{ marginTop: "32px" }}
                  >
                    Reset
                  </button>
                </div>
              </div>
              {alert.show && <AlertBox {...alert} setAlert={setAlert} />}
              <div style={{ overflowX: "auto", marginBottom: "10px" }}>
                <table className="table table-sm table-striped table-hover table-bordered">
                  <thead>
                    <tr>
                      <th>Waktu</th>
                      <th>Provider</th>
                      <th>Whatsapp Key</th>
                      <th>Nama Penerima</th>
                      <th>No HP</th>
                      <th>Tipe Referensi</th>
                      <th>No Referensi</th>
                    </tr>
                  </thead>
                  <tbody>
                    {logs.length === 0 && (
                      <tr>
                        <td colSpan={7} className="text-center">
                          Tidak ada data
                        </td>
                      </tr>
                    )}
                    {logs.map((log) => (
                      <tr key={log.id}>
                        <td className="text-nowrap">
                          {moment.unix(log.created_at).format("DD MMM YYYY - HH:mm:ss")}
                        </td>
                        <td>{log.provider}</td>
                        <td>{log.whatsapp_key}</td>
                        <td>{log.recipient_name}</td>
                        <td>{log.recipient_phone}</td>
                        <td>{log.reference_type}</td>
                        <td>{log.reference_number}</td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
              {meta.count > meta.page_size && (
                <Pagination
                  totalpage={Math.ceil(meta.count / meta.page_size)}
                  selectedpage={meta.page}
                  clickpage={(page) => gotoPage(page)}
                  next={() => gotoPage(meta.page + 1)}
                  prev={() => gotoPage(meta.page - 1)}
                />
              )}
            </Box>
          </div>
        </div>
      </div>
    </MainLayout>
  );
}
